import React, { useState } from 'react';
import { ReactComponent as ArrowRightIcon } from 'assets/svg/arrow-right.svg';
import classNames from 'classnames';

const Section = ({ title, children, defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  const onChangeOpen = () => {
    setOpen(!open);
  };
  return (
    <div className="section-container">
      <div className="section-container__header" onClick={onChangeOpen}>
        <ArrowRightIcon
          className={classNames('section-container__header-icon', {
            'section-container__header-icon--open': open,
          })}
        />
        <div className="section-container__title">{title}</div>
      </div>
      <div
        className={classNames('section-container__body', {
          'section-container__body--expand': open,
        })}
      >
        <div style={{ padding: '1rem' }}>{children && children}</div>
      </div>
    </div>
  );
};

export default Section;
